import { useEffect } from "react";

const useAutoScroll = (selector, speed = 0.5, delay = 16) => {
  useEffect(() => {
    const container = document.querySelector(selector);
    if (!container) return;

    if (container.children.length === 0) return;

    // Clone once
    if (!container.dataset.cloned) {
      container.dataset.cloned = "true";
      container.innerHTML += container.innerHTML;
    }

    let paused = false;
    let resumeTimer;

    const pause = () => {
      paused = true;
      clearTimeout(resumeTimer);
    };

    const resume = () => {
      resumeTimer = setTimeout(() => {
        paused = false;
      }, 2000); // calm delay (autism-friendly)
    };

    const tick = () => {
      if (!paused) {
        container.scrollLeft += speed;

        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
    };

    const interval = setInterval(tick, delay);

    // real user interactions only
    container.addEventListener("mouseenter", pause);
    container.addEventListener("mouseleave", resume);
    container.addEventListener("wheel", pause);
    container.addEventListener("touchstart", pause);
    container.addEventListener("mousedown", pause);

    return () => {
      clearInterval(interval);
      clearTimeout(resumeTimer);
    };
  }, [selector, speed, delay]);
};

export default useAutoScroll;
